<template>
    <div v-if="requestsInProgress === 0">
        <div class="field">
            <label class="label">{{ translate("page.start_fights.choose_mat") }}</label>
            <div class="select">
                <select v-model="selectedMatId">
                    <option value="0">--------</option>
                    <option :value="mat.id" v-for="mat in mats" :key="mat.id">{{ mat.name }}</option>
                </select>
            </div>
        </div>
        <button class="button is-primary" @click="selectMat" :disabled="!validMatIsSelected">
            {{ translate("common.ok") }}
        </button>
    </div>
    <LoadingSpinner2 v-else />
</template>

<script>
    import apiMixin from "../Api/apiMixin";
    import translatorMixin from "../Common/translatorMixin";
    import errorHandlerMixin from "../Common/errorHandlerMixin";
    import LoadingSpinner2 from "../Common/LoadingSpinner2.vue";

    export default {
        name: "referee-mat-select",
        components: { LoadingSpinner2 },
        mixins: [apiMixin, translatorMixin, errorHandlerMixin],
        props: ["eventId"],
        data() {
            return {
                mats: [],
                selectedMatId: 0,
            };
        },
        computed: {
            validMatIsSelected() {
                return parseInt(this.selectedMatId) > 0;
            },
        },
        methods: {
            init() {
                this.mats = [];
                return this.fetchMats();
            },
            fetchMats() {
                return this.matsApi()
                    .getMatsListing(this.eventId)
                    .then(mats => (this.mats = mats))
                    .catch(this.handleError);
            },
            selectMat() {
                this.$emit("matIdSelected", this.selectedMatId);
            },
        },
    };
</script>

<style scoped></style>
